import Vue from 'vue';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


import LoadingPlugin from './components/BGLoading';
import App from './App';
import store from './store/index';
import filters from './filters/filters';
import {router} from './router/index';

import 'lib-flexible';

import i18n from './lang';

Vue.config.productionTip = false;


Vue.use(AlertPlugin);
Vue.use(LoadingPlugin);
Vue.use(ToastPlugin, {position: 'middle', type: 'text', width: '20em'});
Vue.use(ConfirmPlugin);

document.title = i18n.t('hotel.Book_Hotel');


for(let k in filters){
Vue.filter(`${k}`, filters[k]);
}

new Vue({
el: '#app',
store,
router,
i18n,
components: { App },
template: '<App />',
});



// WEBPACK FOOTER //
// ./src/main.js